import { inject, Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { PopularAirlinesApiService } from './popular-airlines-api.service';
import { IAirlineData } from '../models/airlines.models';
import { IAirlineInfo } from '../models/airlineInfo.models';
import { defaultAirlineInfo } from '../constants/defaultValues/airlineInfo';
import { GET_ALL_AIRLIENS_STATE } from '../constants/states/allAirlines';
import { GET_AIRLIEN_INFO_STATE } from '../constants/states/airlineInfo';
import { PopularAirlinesSharedService } from './popular-airlines-shared.service';
import { TranslateService } from '@ngx-translate/core';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class PopularAirlinesService {
  notify: Subject<string> = new Subject();
  subscription: Subscription = new Subscription();
  isLoading: boolean = false;
  metaTitle: string = '';
  metaDescription: string = '';
  metaKeyword: string = '';
  airlines: IAirlineData[] = [];
  translate = inject(TranslateService);
  airlineInfo: IAirlineInfo = defaultAirlineInfo;
  titleService = inject(Title);
  metaService = inject(Meta);
  popularAirlinesApi = inject(PopularAirlinesApiService);
  sharedAirlineService = inject(PopularAirlinesSharedService);
  getAllAirlines() {
    this.isLoading = true;

    this.subscription.add(
      this.popularAirlinesApi.getAllAirlinesApi().subscribe({
        next: (res) => {
          if (res.status === 0) {
            this.airlines = res.returnObject;
            this.isLoading = false;
            this.notify.next(GET_ALL_AIRLIENS_STATE.success);
          } else {
            this.isLoading = false;
            this.notify.next(GET_ALL_AIRLIENS_STATE.faild);
          }
        },
        error: () => {
          this.isLoading = false;
          this.notify.next(GET_ALL_AIRLIENS_STATE.faild);
        },
      }),
    );
  }

  getAirlineInfo(iatacode: string) {
    this.isLoading = true;
    this.subscription.add(
      this.popularAirlinesApi.getAirlineInfoApi(iatacode).subscribe({
        next: (res) => {
          if (res.status === 0) {
            this.airlineInfo = res.returnObject;
            this.isLoading = false;
            this.notify.next(GET_AIRLIEN_INFO_STATE.success);
            if (this.translate.currentLang === 'en') {
              this.metaTitle =
                this.airlineInfo.airlineContentDto.airlineContentDetailDto[0].metaTitle;
              this.metaDescription =
                this.airlineInfo.airlineContentDto.airlineContentDetailDto[0].metaDesc;
              this.metaKeyword =
                this.airlineInfo.airlineContentDto.airlineContentDetailDto[0].metaKeyword;
            } else if (this.translate.currentLang === 'ar') {
              this.metaTitle =
                this.airlineInfo.airlineContentDto.airlineContentDetailDto[1].metaTitle;
              this.metaDescription =
                this.airlineInfo.airlineContentDto.airlineContentDetailDto[1].metaDesc;
              this.metaKeyword =
                this.airlineInfo.airlineContentDto.airlineContentDetailDto[1].metaKeyword;
            }
            this.titleService.setTitle(this.metaTitle);
            this.metaService.updateTag({
              name: 'description',
              content: this.metaDescription,
            });
            this.metaService.updateTag({
              name: 'keywords',
              content: this.metaKeyword,
            });
          } else {
            this.isLoading = false;
            this.notify.next(GET_AIRLIEN_INFO_STATE.faild);
          }
        },
        error: () => {
          this.isLoading = false;
          this.notify.next(GET_AIRLIEN_INFO_STATE.faild);
        },
      }),
    );
  }
}
